import { TagIcon } from "../atoms/TagIcon";

type DiscountBadgeProps = {
  text?: string;
};

export const DiscountBadge = ({
  text = "50% Special Discount!",
}: DiscountBadgeProps) => (
  <div className="discount-badge">
    <TagIcon />
    <span className="discount-text">{text}</span>
  </div>
);
